import "./Imprint.module.css";
import Header from "@/reusable_sections/Header";
import ImpressumDetails from "./sections/ImpressumDetails";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import AboutUsPhilosophy from "./sections/AboutUsPhilosophy";
import Footer from "@/reusable_sections/Footer";
export default function ImprintPage() {
  return <div>
      <Header />
      <ImpressumDetails />
      <FrequentlyAskedQuestions />
      <AboutUsPhilosophy />
      <Footer />
    </div>;
}